var _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OUTLINE",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 47,
    viewBox: "7 0 43 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "28 46 28 26.14 32.36 29.77 33.64 28.23 28.56 24 33.64 19.77 32.36 18.23 28 21.86 28 13 26 13 26 21.86 21.64 18.23 20.36 19.77 25.44 24 20.36 28.23 21.64 29.77 26 26.14 26 46 28 46"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "14.29 25.65 8.5 31.75 22.78 34.98 23.22 33.02 12.37 30.58 16.95 25.74 9.75 16.99 18.31 16.21 17.77 9.63 22.31 12.65 27 4.93 31.69 12.65 36.23 9.63 35.69 16.21 44.25 16.99 37.05 25.74 41.63 30.58 30.78 33.02 31.22 34.98 45.5 31.75 39.72 25.65 48.2 15.34 37.85 14.4 38.56 5.67 32.32 9.83 27 1.07 21.68 9.83 15.44 5.67 16.15 14.4 5.8 15.34 14.29 25.65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFall);
export default __webpack_public_path__ + "static/media/fall.67c013a6a66542898742b0ceb5455abf.svg";
export { ForwardRef as ReactComponent };